exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-blue[data-v-4463be27]{\n      background-color: #2A307D !important;\n}\n", ""]);

// exports
